// src/components/home/SaveStatus.js
// "Saving… / Saved / Couldn't save, retrying" for the home page's private cards.

const TEXT = {
  saving: "Saving…",
  saved: "Saved",
  retrying: "Couldn't save, retrying",
};

export default function SaveStatus({ status, errorText }) {
  const text = status === "error" ? errorText || "Couldn't save." : TEXT[status] || "";
  return (
    <span
      role="status"
      aria-live="polite"
      className={`text-[11px] ${status === "retrying" || status === "error" ? "rx-home-warn" : "rx-home-muted"}`}
    >
      {text}
    </span>
  );
}
